import { render, staticRenderFns } from "./jieji.vue?vue&type=template&id=67289a1a&scoped=true&"
import script from "./jieji.vue?vue&type=script&lang=js&"
export * from "./jieji.vue?vue&type=script&lang=js&"
import style0 from "./jieji.vue?vue&type=style&index=0&id=67289a1a&lang=scss&scoped=true&"
import style1 from "./jieji.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67289a1a",
  null
  
)

export default component.exports